"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// See http://redux-form.com/6.4.3/examples/material-ui/
var renderInput = function renderInput(props) {
  var _props$meta = props.meta;
  _props$meta = _props$meta === void 0 ? {} : _props$meta;

  var touched = _props$meta.touched,
      error = _props$meta.error,
      input = props.input,
      rest = _objectWithoutProperties(props, ["meta", "input"]);

  return _react.default.createElement(_core.TextField, _extends({
    error: Boolean(touched && error),
    helperText: touched && error
  }, input, rest, {
    fullWidth: true
  }));
};

renderInput.propTypes = {
  meta: _propTypes.default.object.isRequired,
  input: _propTypes.default.object.isRequired
};
var _default = renderInput;
exports.default = _default;